import {
  ReactNode,
  createContext,
  useContext,
  useState,
} from 'react';

interface AlertContextProps {
  showAlert: boolean;
  setShowAlert: (value: boolean) => void;
}

const AlertContext = createContext<AlertContextProps | undefined>(undefined);

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return { showAlert: false, setShowAlert: () => { }, isLoading: true };
  }
  return context;
};

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
  const [showAlert, setShowAlert] = useState(true);
  return (
    <AlertContext.Provider value={{ showAlert, setShowAlert }}>
      {children}
    </AlertContext.Provider>
  );
};
